import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    path_s3: 'https://s3-ap-southeast-1.amazonaws.com/apsth-assets-upload/',
  },
  mutations: {
  },
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    app,
  },
})
